<template>
  <section class="batch-modify seven-day-return-batch">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" :disabled="locked" @click="$emit('back')">‹ 返回</button
        ><span>商品工作台　›　批量修改　›　<strong>7天无理由退货</strong></span>
      </div>
      <h1>批量修改7天无理由退货</h1>
      <nav>
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ active: mode === tab.value }"
          :disabled="locked"
          @click="switchMode(tab.value)"
        >
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main>
      <p v-if="policiesLoading" class="hint">正在读取已存退货政策…</p>
      <p v-if="policiesError" class="load-error">
        {{ policiesError }}
        <button class="plain" @click="loadStoredPolicies">重试读取政策</button>
      </p>
      <p v-if="optionsError" class="load-error">
        {{ optionsError }}
        <button class="plain" @click="loadOptions">重试加载</button>
      </p>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button :disabled="locked" @click="openSelector">选择商品</button
          ><span
            >已选择 <b>{{ selected.length }}</b> 个商品</span
          >
        </div>
        <div v-else-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label
          ><el-input
            v-model="idsText"
            :disabled="locked"
            type="textarea"
            :rows="3"
            placeholder="多个 ID 用逗号、空格或换行分隔，最多2000个"
          />
        </div>
        <div v-else class="filters" @keyup.enter="loadPreview(1)">
          <label v-for="field in shownFields" :key="field.key" class="field">
            <span>{{ field.label }}</span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categories"
              :disabled="locked"
            />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              :disabled="locked"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :disabled="locked"
                ><el-option v-for="o in field.matchOptions" :key="o.value" :value="o.value" :label="o.label"
              /></el-select>
              <div v-if="field.range" class="range">
                <input v-model="filters[field.key + '_min']" :disabled="locked" placeholder="最小值" /><span>~</span
                ><input v-model="filters[field.key + '_max']" :disabled="locked" placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :disabled="locked"
                :placeholder="field.placeholder || '请输入' + field.label"
              />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filters[field.key + '_min']" :disabled="locked" placeholder="最小值" /><span>~</span
              ><input v-model="filters[field.key + '_max']" :disabled="locked" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filters[field.key]" :disabled="locked" clearable
              ><el-option v-for="o in field.options" :key="String(o.value)" :value="o.value" :label="o.label"
            /></el-select>
            <input
              v-else
              v-model="filters[field.key]"
              :disabled="locked"
              :placeholder="field.placeholder || '请输入条件'"
            />
          </label>
        </div>
        <footer class="filter-actions">
          <doudian-batch-shop-scope v-model="shops" :shops="shopOptions" :disabled="locked" @input="changeShops" />
          <div class="filter-buttons">
            <button :disabled="locked || loading || !policiesReady" @click="loadPreview(1)">查询</button
            ><button class="plain" :disabled="locked" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p class="hint">按本地数据筛选，执行时读取抖店详情复核。</p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="locked || loading" />
      <section class="panel methods freight-content policy-methods">
        <h3><i></i>修改内容</h3>
        <div class="method-body">
          <div class="policy-query-fields">
            <div class="method policy-query-row">
              <span>查询店铺</span>
              <div class="method-controls policy-query-controls">
                <el-select
                  v-model="policyShopId"
                  :disabled="locked || policyLoading"
                  filterable
                  clearable
                  placeholder="请选择查询店铺（必选）"
                >
                  <el-option
                    v-for="shop in shopOptions"
                    :key="shop.mer_shop_id"
                    :value="Number(shop.mer_shop_id)"
                    :label="shop.shop_name"
                  />
                </el-select>
              </div>
            </div>
            <div class="method policy-query-row">
              <span>查询政策类目</span>
              <div class="method-controls policy-query-controls">
                <doudian-category-cascader
                  v-model="policyCategorySelection"
                  class="policy-category-picker"
                  :categories="categories"
                  :max-selected="5"
                  :disabled="locked || policyLoading"
                  placeholder="请选择叶子类目，最多5个"
                />
                <button
                  :disabled="locked || policyLoading || !policyScope.shop_ids.length || !policyCategories.length"
                  @click="loadPolicies"
                >
                  {{ policyLoading ? '查询中…' : '获取退货政策' }}
                </button>
              </div>
            </div>
          </div>
          <p v-if="policyError" class="load-error">{{ policyError }}</p>
          <p class="hint">
            需要补充政策时，选择一个查询店铺，最多查询5个叶子类目。优先按已存类目政策匹配；未查询过的类目在执行时使用商品所属店铺自动查询并存表，再按优先级匹配，全部不支持的商品会修改失败。
            优先级选项优先读取已存政策；如缺少所需选项，请查询补充，成功后自动存表。重复查询不清空已选优先级。
          </p>
          <div v-for="(value, index) in priorities" :key="index" class="method">
            <span>优先级 {{ index + 1 }}</span>
            <div class="method-controls">
              <el-select
                :value="value"
                :disabled="locked || !policiesReady"
                placeholder="请选择退货政策"
                @input="$set(priorities, index, $event)"
              >
                <el-option
                  v-for="option in policyOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label"
                  :disabled="priorities.includes(option.value) && value !== option.value"
                />
              </el-select>
              <button :disabled="locked || index === 0" @click="movePriority(index, -1)">上移</button>
              <button :disabled="locked || index === priorities.length - 1" @click="movePriority(index, 1)">
                下移
              </button>
              <button :disabled="locked" @click="priorities.splice(index, 1)">删除</button>
            </div>
          </div>
          <button
            :disabled="locked || !policiesReady || priorities.length >= policyOptions.length"
            @click="priorities.push('')"
          >
            添加优先级
          </button>
        </div>
      </section>
      <section v-if="preview" class="panel preview">
        <header class="preview-summary">
          <span
            >候选 <b>{{ preview.total }}</b> 个，已排除 {{ preview.excluded_total }} 个，本次提交
            {{ preview.selected_total }} 个；本页预计命中 {{ counts.ready }}、预计跳过 {{ counts.skipped }}、待核验
            {{ counts.unknown }}、预计失败 {{ counts.failed }}</span
          ><button class="plain" :disabled="locked" @click="invalidate">收起预览</button>
        </header>
        <p class="hint">
          预览依据本地快照和已存类目政策，不查询抖店规则；未查询过的类目显示待核验，执行时自动补查。实际命中和修改结果以执行时抖店详情复核及平台回执为准。
        </p>
        <p v-if="preview.missing_product_ids && preview.missing_product_ids.length" class="load-error">
          本地未匹配或不属于当前店铺的商品 ID：{{ preview.missing_product_ids.join('、') }}
        </p>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>商品信息</th>
                <th>原7天无理由退货政策</th>
                <th>目标7天无理由退货政策</th>
                <th>预览结果</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in preview.list" :key="item.id" :class="{ excluded: excluded.includes(Number(item.id)) }">
                <td>
                  <div class="preview-product">
                    <img v-if="item.main_image" class="preview-product-image" :src="item.main_image" alt="商品主图" />
                    <div>
                      {{ item.product_title }}<small>{{ item.shop_name }}<br />{{ item.platform_product_id }}</small>
                    </div>
                  </div>
                </td>
                <td>
                  {{ countLabel(item.old_values && item.old_values.selector) }}
                </td>
                <td>
                  {{ countLabel(item.target_values && item.target_values.selector) }}
                </td>
                <td>
                  {{ resultLabels[item.preview_result] || '待核验' }}<small>{{ item.reason_text }}</small>
                </td>
                <td>
                  <el-checkbox
                    :value="excluded.includes(Number(item.id))"
                    :disabled="locked || loading"
                    @change="exclude(item.id, $event)"
                    >排除修改</el-checkbox
                  >
                </td>
              </tr>
              <tr v-if="!preview.list.length">
                <td colspan="5" class="empty">暂无符合条件的商品</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :disabled="locked || loading"
            :current-page="preview.page"
            :page-size="preview.limit"
            :total="preview.total"
            @current-change="loadPreview"
          />
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button class="preview-button" :disabled="locked || loading || !policiesReady" @click="loadPreview(1)">
        {{ loading ? '加载中…' : '修改内容预览' }}
      </button>
      <button v-if="createUncertain" class="start" :disabled="submitting" @click="submitFrozen">确认创建结果</button>
      <button
        v-else
        class="start"
        :disabled="locked || loading || !policiesReady || !previewCurrent"
        @click="createBatch"
      >
        {{ submitting ? '创建中…' : '开始批量修改' }}
      </button>
      <label><input v-model="scheduled" type="checkbox" :disabled="locked" />定时执行</label>
      <el-date-picker
        v-if="scheduled"
        v-model="scheduledAt"
        :disabled="locked"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="选择北京时间"
      />
    </footer>
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="selectorRows.length > 0 && selectorRows.every(isSelected)"
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @close="closeSelector"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = $event"
      @jump="changeSelectorPage(Number(selectorJump))"
      @confirm="confirmSelected"
    >
      <template #filters
        ><doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)"
      /></template>
    </product-selector-dialog>
  </section>
</template>

<script>
import {
  previewDoudianSevenDayReturnBatch,
  createDoudianSevenDayReturnBatch,
  getDoudianCategories,
  getDoudianSevenDayReturnShops,
  getDoudianSevenDayReturnOptions,
  getDoudianSevenDayReturnPolicies,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import DoudianBatchShopScope from '@/components/DoudianBatchShopScope'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianBatchCommonOptions from '@/components/DoudianBatchCommonOptions'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import { fields, pairedFields, defaults, buildBatchProductFilter } from './batchModifyFilters'

const selectorDefaults = () => ({
  category_id: { level1: [], level2: [], level3: [] },
  platform_product_id: '',
  product_title: '',
  created_at: [],
  tab_status: ''
})
const supportedFields = fields.filter((field) => !['quality', 'has_exposure'].includes(field.key))

export default {
  name: 'BatchModifySevenDayReturn',
  components: {
    DoudianCategoryCascader,
    DoudianBatchShopScope,
    ProductSelectorDialog,
    DoudianBatchCommonOptions,
    DoudianProductSelectorFilters
  },
  data: () => ({
    tabs: [
      { value: 'range', label: '按范围修改' },
      { value: 'products', label: '按商品修改' },
      { value: 'product_ids', label: '按商品 ID 修改' }
    ],
    mode: 'range',
    filters: defaults(),
    shops: [],
    selectorShopId: '',
    shopOptions: [],
    categories: [],
    policiesLoading: false,
    policiesError: '',
    optionsLoading: false,
    optionsError: '',
    policyShopId: '',
    policyCategories: [],
    policyOptions: [],
    priorities: [],
    policyLoading: false,
    policyError: '',
    policyRequest: 0,
    selected: [],
    excluded: [],
    idsText: '',
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: '',
    preview: null,
    signature: '',
    loading: false,
    previewRequest: 0,
    requestId: '',
    confirming: false,
    submitting: false,
    createUncertain: false,
    frozenBody: null,
    selectorVisible: false,
    selectorTab: 'all',
    selectorLoading: false,
    selectorRows: [],
    selectorPageSize: 20,
    selectorPage: 1,
    selectorTotal: 0,
    selectorJump: 1,
    selectorFilters: selectorDefaults(),
    draftSelected: [],
    selectorRequest: 0,
    resultLabels: {
      ready: '预计命中',
      skipped: '预计跳过',
      unknown: '待核验',
      failed: '预计失败'
    }
  }),
  computed: {
    policyCategorySelection: {
      get() {
        return { level1: [], level2: [], level3: this.policyCategories }
      },
      set(value) {
        this.policyCategories = [
          ...new Set([...(value.level1 || []), ...(value.level2 || []), ...(value.level3 || [])])
        ]
      }
    },
    policyScope() {
      return {
        shop_ids: this.policyShopId ? [Number(this.policyShopId)] : [],
        category_ids: [...new Set(this.policyCategories.map(Number))].sort((a, b) => a - b)
      }
    },
    policiesReady() {
      return !this.policyLoading && this.policyOptions.length > 0
    },
    locked() {
      return this.confirming || this.submitting || this.createUncertain
    },
    shownFields() {
      return supportedFields
        .filter((f) => !Object.values(pairedFields).includes(f.key))
        .map((f) =>
          pairedFields[f.key]
            ? {
                ...f,
                matchKey: pairedFields[f.key],
                matchOptions: fields.find((x) => x.key === pairedFields[f.key]).options
              }
            : f
        )
    },
    previewCurrent() {
      return !!(this.preview && this.signature === JSON.stringify(this.payload(false)))
    },
    counts() {
      return (
        this.preview?.page_match_counts || {
          ready: 0,
          skipped: 0,
          unknown: 0,
          failed: 0
        }
      )
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil((this.selectorTab === 'selected' ? this.draftSelected.length : this.selectorTotal) / this.selectorPageSize)
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice((this.selectorPage - 1) * this.selectorPageSize, this.selectorPage * this.selectorPageSize)
        : this.selectorRows
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    commonOptions: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    priorities: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    policyScope: {
      deep: true,
      handler() {
        this.cancelPolicyQuery()
      }
    },
    idsText() {
      this.invalidate()
    },
    scheduled() {
      if (!this.scheduled) this.scheduledAt = ''
      this.invalidate()
    },
    scheduledAt() {
      this.invalidate()
    }
  },
  mounted() {
    this.newRequestId()
    this.loadOptions()
  },
  beforeDestroy() {
    this.previewRequest++
    this.selectorRequest++
    this.policyRequest++
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size)
      this.selectorPage = 1
      this.loadSelector(1)
    },
    dataOf(response) {
      if (!response || Number(response.code) !== 200) {
        const error = new Error(response?.message || '请求失败')
        error.businessFailure = true
        throw error
      }
      return response.data
    },
    message(error) {
      return error?.response?.data?.message || error?.message || '请求失败'
    },
    newRequestId() {
      this.requestId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        return (c === 'x' ? r : (r & 3) | 8).toString(16)
      })
    },
    invalidate() {
      this.previewRequest++
      this.preview = null
      this.signature = ''
      this.loading = false
      if (!this.locked) this.newRequestId()
    },
    async loadStoredPolicies() {
      this.policiesLoading = true
      this.policiesError = ''
      try {
        const policies = this.dataOf(await getDoudianSevenDayReturnPolicies())
        if (this._isDestroyed) return
        this.mergePolicies(policies.options || [])
      } catch (error) {
        if (!this._isDestroyed) this.policiesError = '已存退货政策读取失败：' + this.message(error)
      } finally {
        if (!this._isDestroyed) this.policiesLoading = false
      }
    },
    async loadOptions() {
      this.optionsLoading = true
      this.optionsError = ''
      const results = await Promise.allSettled([
        this.loadStoredPolicies(),
        (async () => {
          const data = this.dataOf(await getDoudianSevenDayReturnShops())
          if (!this._isDestroyed) this.shopOptions = Array.isArray(data) ? data : data.list || data.data || []
        })(),
        (async () => {
          const categories = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
          if (this._isDestroyed) return
          const map = (rows) =>
            rows.map((x) => ({
              ...x,
              category_id: x.id || x.category_id,
              category_name: x.name || x.category_name,
              children: map(x.children || [])
            }))
          this.categories = map(Array.isArray(categories) ? categories : categories.list || categories.data || [])
        })()
      ])
      if (this._isDestroyed) return
      this.optionsError = results
        .slice(1)
        .map((result, index) =>
          result.status === 'rejected'
            ? (index === 0 ? '店铺加载失败：' : '类目加载失败：') + this.message(result.reason)
            : ''
        )
        .filter(Boolean)
        .join('；')
      this.optionsLoading = false
    },
    changeShops() {
      this.excluded = []
      this.invalidate()
    },
    changeSelectorShop(id) {
      this.selectorShopId = id
      this.loadSelector(1)
    },
    cancelPolicyQuery() {
      this.policyRequest++
      this.policyLoading = false
      this.policyError = ''
    },
    async loadPolicies() {
      if (this.locked) return
      const scope = JSON.parse(JSON.stringify(this.policyScope))
      this.cancelPolicyQuery()
      if (!scope.shop_ids.length || !scope.category_ids.length) return this.$message.warning('请先选择店铺和类目')
      if (scope.shop_ids.length !== 1 || scope.category_ids.length > 5)
        return this.$message.warning('请选择一个查询店铺，最多选择5个叶子类目')
      const signature = JSON.stringify(scope),
        request = ++this.policyRequest
      this.policyLoading = true
      try {
        const data = this.dataOf(await getDoudianSevenDayReturnOptions(scope))
        if (request !== this.policyRequest || signature !== JSON.stringify(this.policyScope) || this._isDestroyed)
          return
        if (!data.complete || !Array.isArray(data.options) || !data.options.length)
          throw new Error('所选类目没有可选的七天退货政策')
        this.mergePolicies(data.options)
        this.$message.success('退货政策获取成功')
      } catch (error) {
        if (request === this.policyRequest && !this._isDestroyed) this.policyError = this.message(error)
      } finally {
        if (request === this.policyRequest && !this._isDestroyed) this.policyLoading = false
      }
    },
    mergePolicies(newOptions) {
      const firstQuery = this.policyOptions.length === 0
      const options = new Map(this.policyOptions.map((option) => [option.value, option]))
      newOptions.forEach((option) => {
        const previous = options.get(option.value)
        options.set(
          option.value,
          previous
            ? {
                ...previous,
                category_ids: [...new Set([...(previous.category_ids || []), ...(option.category_ids || [])])]
              }
            : option
        )
      })
      this.policyOptions = [...options.values()]
      if (firstQuery && this.policyOptions.length) this.priorities = ['']
    },
    movePriority(index, direction) {
      const values = [...this.priorities],
        next = index + direction
      if (this.locked || next < 0 || next >= values.length) return
      ;[values[index], values[next]] = [values[next], values[index]]
      this.priorities = values
    },
    countLabel(value) {
      const option = this.policyOptions.find((x) => x.value === value)
      return option ? option.label : value || '待核验'
    },
    payload(includeRequest = true) {
      let filter =
        this.mode === 'range'
          ? buildBatchProductFilter(this.filters, this.shops, this.excluded, 'range')
          : {
              shop_ids:
                this.mode === 'products'
                  ? this.selected.length
                    ? [Number(this.selected[0].shop_id)]
                    : []
                  : this.shops,
              excluded_product_ids: [...this.excluded],
              platform_product_id:
                this.mode === 'products'
                  ? this.selected.map((x) => String(x.platform_product_id))
                  : [...new Set(this.idsText.split(/[,，\s]+/).filter(Boolean))]
            }
      delete filter.quality_min
      delete filter.quality_max
      delete filter.has_exposure
      const body = {
        selection_mode: this.mode,
        product_filter: filter,
        return_rule: { priorities: [...this.priorities] },
        common_options: { ...this.commonOptions }
      }
      if (includeRequest) {
        body.request_id = this.requestId
        if (this.scheduled) body.scheduled_at = this.scheduledAt
      }
      return body
    },
    validate() {
      if (!this.policiesReady) throw new Error('暂无政策选项，请选择查询店铺和类目补充查询')
      if (
        !this.priorities.length ||
        this.priorities.some((value) => !this.policyOptions.some((option) => option.value === value)) ||
        new Set(this.priorities).size !== this.priorities.length
      )
        throw new Error('请配置不重复且有效的政策优先级')
      if (this.mode === 'products' && !this.selected.length) throw new Error('请选择商品')
      const ids = this.payload(false).product_filter.platform_product_id
      if (
        this.mode === 'product_ids' &&
        (!ids.length || ids.length > 2000 || ids.some((id) => !/^[1-9][0-9]{0,199}$/.test(id)))
      )
        throw new Error('请输入有效抖店商品 ID，最多2000个')
      if (this.selected.some((x) => Number(x.shop_id) !== Number(this.selected[0].shop_id)))
        throw new Error('只能选择同一家店铺的商品')
      if (
        this.scheduled &&
        (!this.scheduledAt ||
          !Number.isFinite(Date.parse(this.scheduledAt.replace(' ', 'T') + '+08:00')) ||
          Date.parse(this.scheduledAt.replace(' ', 'T') + '+08:00') <= Date.now())
      )
        throw new Error('定时时间必须为未来的北京时间')
    },
    switchMode(mode) {
      if (this.locked || this.mode === mode) return
      this.mode = mode
      this.selected = []
      this.excluded = []
      this.idsText = ''
      this.closeSelector()
      this.invalidate()
    },
    async loadPreview(page = 1) {
      if (this.locked) return
      try {
        this.validate()
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const body = this.payload(false),
        signature = JSON.stringify(body),
        request = ++this.previewRequest
      this.loading = true
      try {
        const data = this.dataOf(await previewDoudianSevenDayReturnBatch({ ...body, page, limit: 20 }))
        if (request !== this.previewRequest || signature !== JSON.stringify(this.payload(false)) || this._isDestroyed)
          return
        this.preview = data
        this.signature = signature
      } catch (error) {
        if (request === this.previewRequest && !this._isDestroyed) {
          this.invalidate()
          this.$message.error(this.message(error))
        }
      } finally {
        if (request === this.previewRequest && !this._isDestroyed) this.loading = false
      }
    },
    async createBatch() {
      try {
        this.validate()
        if (!this.previewCurrent) throw new Error('请先预览当前修改内容')
        if (!this.preview.selected_total || this.preview.total > 10000)
          throw new Error('候选商品需为1至10000件且不能全部排除')
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const body = this.payload(),
        signature = JSON.stringify(body)
      this.confirming = true
      try {
        await this.$confirm(
          `将按所选政策优先级修改${this.preview.selected_total}个商品。未查询过的类目将在执行时自动查询并保存政策；查询失败或全部优先级均不支持的商品会失败。确定开始吗？`,
          '确认修改'
        )
        this.validate()
        if (signature !== JSON.stringify(this.payload())) throw new Error('设置已变化，请重新预览')
        this.frozenBody = body
        await this.submitFrozen()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(this.message(error))
      } finally {
        this.confirming = false
      }
    },
    async submitFrozen() {
      if (this.submitting || !this.frozenBody) return
      this.submitting = true
      try {
        this.dataOf(await createDoudianSevenDayReturnBatch(this.frozenBody))
        this.createUncertain = false
        this.$message.success('任务已创建，请查看批量修改记录')
        this.$emit('created')
      } catch (error) {
        this.createUncertain = !error?.response && !error?.businessFailure
        this.$message.error(
          this.createUncertain ? '创建结果待核实，请点击确认创建结果；系统将复用同一请求' : this.message(error)
        )
      } finally {
        this.submitting = false
      }
    },
    exclude(id, checked) {
      const n = Number(id)
      this.excluded = checked ? [...new Set([...this.excluded, n])] : this.excluded.filter((x) => x !== n)
      this.invalidate()
    },
    resetFilters() {
      this.filters = defaults()
      this.selected = []
      this.excluded = []
      this.idsText = ''
      this.invalidate()
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id)
    },
    productTitle(item) {
      return item.product_title || item.title || ''
    },
    productImage(item) {
      return item.main_image || item.img || ''
    },
    productPrice(item) {
      return item.product_price == null ? '价格待定' : '¥' + Number(item.product_price).toFixed(2)
    },
    isSelected(item) {
      return this.draftSelected.some((x) => this.productId(x) === this.productId(item))
    },
    openSelector() {
      this.draftSelected = [...this.selected]
      this.selectorTab = 'all'
      this.selectorVisible = true
      this.loadSelector(1)
    },
    closeSelector() {
      this.selectorRequest++
      this.selectorVisible = false
      this.selectorLoading = false
    },
    toggleProduct(item) {
      if (
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(item.shop_id) !== Number(this.draftSelected[0].shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter((x) => this.productId(x) !== this.productId(item))
        : [...this.draftSelected, item]
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected)
      this.selectorRows.forEach((x) => {
        if (this.isSelected(x) === all) this.toggleProduct(x)
      })
    },
    changeSelectorTab(tab) {
      this.selectorRequest++
      this.selectorLoading = false
      this.selectorTab = tab
      this.changeSelectorPage(1)
    },
    changeSelectorPage(page) {
      const p = Math.max(1, Math.min(this.selectorPages, Number(page) || 1))
      if (this.selectorTab === 'all') this.loadSelector(p)
      else {
        this.selectorPage = p
        this.selectorJump = p
      }
    },
    confirmSelected() {
      if (this.draftSelected.some((x) => Number(x.shop_id) !== Number(this.draftSelected[0].shop_id)))
        return this.$message.warning('只能选择同一家店铺的商品')
      this.selected = [...this.draftSelected]
      this.closeSelector()
      this.excluded = []
      this.invalidate()
    },
    async loadSelector(page) {
      const request = ++this.selectorRequest,
        shopId = this.selectorShopId
      this.selectorLoading = true
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            ...this.selectorFilters,
            page,
            page_size: this.selectorPageSize,
            ...(shopId ? { shop_ids: [shopId] } : {})
          })
        )
        if (request !== this.selectorRequest || shopId !== this.selectorShopId || this._isDestroyed) return
        this.selectorRows = data.list || []
        this.selectorPage = page
        this.selectorJump = page
        this.selectorTotal = Number(data.pagination?.total || data.total || 0)
      } catch (error) {
        if (request === this.selectorRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.selectorRequest && !this._isDestroyed) this.selectorLoading = false
      }
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>
<style scoped>
.policy-query-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 24px;
}
.policy-query-fields > .method {
  min-width: 0;
  max-width: 100%;
}
.policy-methods {
  position: relative;
  z-index: 30;
  overflow: visible;
}
.policy-category-picker ::v-deep .cascader-panel {
  top: auto;
  bottom: calc(100% + 4px);
  z-index: 4001;
}
.policy-query-row {
  font-size: 13px;
}
.policy-query-row > span {
  flex-shrink: 0;
}
.policy-query-controls {
  min-width: 0;
  max-width: 100%;
  gap: 12px;
}
.policy-query-controls > .el-select {
  width: 220px;
  max-width: 100%;
}
.policy-query-controls ::v-deep .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}
.policy-category-picker {
  width: 320px;
  max-width: 100%;
}
.policy-category-picker ::v-deep .cascader-input {
  height: 32px;
  font-size: 13px;
}
.policy-category-picker ::v-deep .cascader-placeholder {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.policy-category-picker ::v-deep .el-checkbox__label,
.policy-category-picker ::v-deep .el-input__inner,
.policy-category-picker ::v-deep .cascader-footer button,
.policy-query-controls > button {
  font-size: 13px;
}
.policy-query-controls > button {
  height: 32px;
  flex-shrink: 0;
  white-space: nowrap;
}
@media (max-width: 640px) {
  .policy-query-controls {
    width: 100%;
  }
  .policy-category-picker {
    width: 100%;
  }
}
.preview-product-image {
  object-fit: cover;
}
</style>
